import React from 'react';
import PropTypes from 'prop-types';
import styles from './CaptchaVerifyMessage.scss';

const captchaErrorMessage =
  "Seems you aren't a human or have internet connection error";
const captchaPendingMessage = 'Wait a moment...';

const CaptchaVerifyMessage = ({ isCaptchaVerified, isCaptchaPending }) => {
  if (isCaptchaPending) {
    return <div className={styles.message}>{captchaPendingMessage}</div>;
  }
  if (!isCaptchaVerified) {
    return <div className={styles.errorMessage}>{captchaErrorMessage}</div>;
  }
};

CaptchaVerifyMessage.propTypes = {
  isCaptchaVerified: PropTypes.bool,
  isCaptchaPending: PropTypes.bool,
};

export default CaptchaVerifyMessage;
